import styled from 'styled-components';
import colors from 'theme/colors';

export const CardTabsStyled = styled.div`
  width: 100%;
  display: flex;
  .ant-tabs {
    width: 100%;
    background: ${colors.white};
    margin-top: 1rem;
    .ant-tabs-nav {
      padding-left: 1.5rem;
      margin: 0 !important;
      border-top: 0.063rem solid ${colors.darkestGray};
      border-left: 0.063rem solid ${colors.darkestGray};
      border-right: 0.063rem solid ${colors.darkestGray};
    }

    .ant-tabs-content {
      .ant-card {
        border-top: none;
        .ant-card-body {
          height: 12.5rem;
        }
      }
    }
  }
`;
